<script lang="ts" setup>
// ================================
// IMPORTS
// ================================
// Vue
import { computed } from "vue"

// Store
import { useSourceStore } from "@core/stores/source.store"
const sourceStore = useSourceStore()

// ================================
// TYPES & INTERFACES
// ================================
type Props = {
    meterId: string
}

// ================================
// PROPS & EMITS
// ================================
const props = defineProps<Props>()

// ================================
// COMPUTED PROPERTIES
// ================================

/**
 * Computed pour récupérer les infos de la source
 */
const getSourceById = computed(() => {
    return sourceStore.getSourceById(props.meterId)
})
</script>

<style scoped>
:deep(.p-tabview-panels) {
    padding: 0;
}
</style>

<template>
    <div class="meter_card_offer mt-6">
        <!-- Si la source est un PDL on affiche le composant pour -->
        <MeterCardOfferPdl
            :meter-id="meterId"
            v-if="getSourceById?.type === 'pdl'"
        />
        <!-- Si la source est un PCE on affiche le composant pour -->
        <MeterCardOfferPce
            v-if="getSourceById?.type?.includes('pce')"
            :meter-id="meterId"
        />
    </div>
</template>
